import { TrackableEventNameEnum } from 'react-use-facebook-pixel';
import { trackCustomEvent } from './facebookPixel';
import { facebookId, debugTrackingEnabled } from 'reactAppConstants';

const logEvent = (event, payload) => {
  try {
    if (debugTrackingEnabled()) {
      console.debug(Tracker.name, event, payload, Tracker.enabled ? 'enabled' : 'disabled');
    }
  } catch(e) {
    console.error(Tracker.name, 'Error while logging', e, event, payload);
  }
};

const trackPageView = () => {
  if (Tracker.enabled) {
    trackCustomEvent(TrackableEventNameEnum.PageView);
  }
  logEvent('pageView');
};

const trackEvent = (payload) => {
  if (Tracker.enabled) {
    trackCustomEvent(TrackableEventNameEnum.Lead, payload);
  }
  logEvent(TrackableEventNameEnum.Lead, payload);
};

const trackPurchaseEvent = (payload, eventData) => {
  if (Tracker.enabled) {
    trackCustomEvent(TrackableEventNameEnum.Purchase, payload, eventData);
  }
  logEvent(TrackableEventNameEnum.Purchase, payload);
};

const Tracker = {
  name: 'Facebook',
  enabled: !!facebookId,
  events: {
    pageView: () => trackPageView(),
    lead: (data) => trackEvent(data),
    registration: () => {},
    addToCart: () => {},
    applyPromoCode: () => {},
    checkoutProgress: () => {},
    purchase: (data, eventData) => trackPurchaseEvent(data, eventData),
    error: () => {},
  },
};

export default Tracker;
